export const SET_MAP_CONTENT = 'MassivePoint/SET_MAP_CONTENT'